/**
 * [DSS] Print — Eigenschaften Bridge
 *
 * Bridges Eigenschaften + Media-with-text block data into the
 * print exposé's specs table via JSON <script> tags.
 */
import { $$, $ } from '../utils/helpers.js';

function escapeHtml(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

export function initPrintStore() {
  if ( ($('[data-dss-eigenschaften-for-print]') || $('[data-dss-media-with-text-for-print]')) &&
       $('[data-dss-print-specs-from-sections]')) {
    renderEigenschaftenFromSections();
  }
}

function renderEigenschaftenFromSections() {
  const tbodyEl = $('[data-dss-print-specs-from-sections]');
  if (!tbodyEl) return;

  const sources = [
    { selector: '[data-dss-eigenschaften-for-print]', name: 'Eigenschaften' },
    { selector: '[data-dss-media-with-text-for-print]', name: 'Media-with-text' },
  ];

  const seen = new Set();
  const allEntries = [];

  sources.forEach(({ selector, name }) => {
    const dataEl = $(selector);
    if (!dataEl) return;
    try {
      const raw = (dataEl.textContent || '').trim();
      if (!raw) return;
      const entries = JSON.parse(raw);
      if (!Array.isArray(entries)) return;
      entries.forEach((e) => {
        if (e && e.title && !seen.has(e.title)) {
          seen.add(e.title);
          allEntries.push(e);
        }
      });
    } catch (err) {
      console.error('[DSS Print] Failed to parse ' + name + ':', err);
    }
  });

  if (!allEntries.length) return;

  const rowsHtml = allEntries
    .map(
      (e) =>
        '<tr><th scope="row">' +
        escapeHtml(e.title) +
        '</th><td>' +
        escapeHtml(e.description || '') +
        '</td></tr>'
    )
    .join('');
  if (rowsHtml) {
    tbodyEl.innerHTML = rowsHtml;

    // Compact mode: >8 entries → smaller font + tighter spacing
    const table = tbodyEl.closest('table');
    if (table && allEntries.length > 8) {
      table.classList.add('dss-product-print__specs-table--compact');
      const printSection = table.closest('.dss-product-print');
      if (printSection) {
        const disclaimer = printSection.querySelector('.dss-product-print__disclaimer');
        if (disclaimer) disclaimer.classList.add('dss-product-print__disclaimer--compact');
      }
    }

    const wrapper = document.querySelector('[data-dss-print-specs-from-sections-wrapper]');
    if (wrapper) wrapper.removeAttribute('hidden');
  }
}
